module.exports = "<div id=\"fullscreen\" class=\"btn-header transparent pull-right\">\r\n        <span> <a (click)=\"onToggle()\" title=\"Full Screen\"><i\r\n                class=\"fa fa-arrows-alt\"></i></a> </span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/layout/header/full-screen/full-screen.component.html
// module id = ../../../../../src/app/shared/layout/header/full-screen/full-screen.component.html
// module chunks = main